<template>
  <div>
    <v-navigation-drawer v-model="customizer.Sidebar_drawer" left :permanent="$vuetify.display.mdAndUp" elevation="10"
      :class="customizer.SidebarColor == 'white' ? '' : 'text-white'" :color="isDark ? '' : customizer.SidebarColor"
      rail-width="75" mobile-breakpoint="md" app :rail="adminMainStore.personalSetting.miniSideBar" expand-on-hover>
      <!-- ---------------------------------------------- -->
      <!---Navigation -->
      <!-- ---------------------------------------------- -->
      <PerfectScrollbar class="scrollnavbar">
        <div class="profile cursor-pointer" @click="toggle = !toggle"
          :style="`background:url('${getFullDomain({ protocol, domain })}/apple_doyac/smart_admin4/img/card-backgrounds/cover-2-lg.png')`">
          <div class="profile-pic">
            <v-avatar size="45">
              <DYImg :src="adminPhoto ?? pictureSet?.thumbnail_s ?? ''"
                width="50" />
            </v-avatar>
          </div>
          <div class="profile-name">
            <h5>{{ name }}({{ userStore.id }})</h5>
          </div>
        </div>

        <v-list class="pt-3 pb-0" bg-color="transparent">
          <slot name="favorite" />
        </v-list>

        <!-- 메뉴 검색: 입력하면 아래 메뉴 트리가 매칭되는 메뉴 목록으로 바뀐다 -->
        <div class="dya-menu-search px-3 pt-1 pb-2">
          <v-text-field :model-value="adminMainStore.menuSearchKeyword" density="compact" variant="solo" flat
            hide-details rounded="lg" clearable placeholder="메뉴 검색" autocomplete="off"
            prepend-inner-icon="fas fa-magnifying-glass"
            @update:model-value="val => adminMainStore.menuSearchKeyword = val ?? ''"
            @keydown.enter="moveToFirstSearchResult" @keydown.esc="adminMainStore.menuSearchKeyword = ''" />
        </div>

        <v-list class="pt-0 pb-3 min-h-3" bg-color="transparent">
          <slot />
        </v-list>
      </PerfectScrollbar>
    </v-navigation-drawer>

    <DYADefaultTopMenu v-model:toggle="toggle"></DYADefaultTopMenu>
  </div>
</template>

<script setup lang="ts">
import { useDark, useToggle } from "@vueuse/core";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { hasDYAMenuAuth, searchDYAMenu } from "~/modules/nuxt3-module-admin-doyac/composables/dya-menu-search";
import { useDYAdminMainStore } from "~/modules/nuxt3-module-admin-doyac/stores/main";
import { useDYAuth } from "~/modules/nuxt3-module-doyac/composables/auth";
import { useCustomizerStore } from "~~/modules/nuxt3-module-admin-doyac/stores/customizer";
import { useDYAppConfig } from "~~/modules/nuxt3-module-doyac/composables/config";
import { getFullDomain } from '~~/modules/nuxt3-module-doyac/libs/utils';
import { useDYUserStore } from '~~/modules/nuxt3-module-doyac/stores/user';

library.add(faMagnifyingGlass)

const isDark = useDark()
const toggleDark = useToggle(isDark)
const customizer = useCustomizerStore();
const adminMainStore = useDYAdminMainStore()
const { name, pictureSet, adminPhoto } = useDYUserStore()
const { domain, protocol } = useDYAppConfig()
const { hasAuth } = useDYAuth()
const router = useRouter()

const toggle = ref(false)
const userStore = useDYUserStore()

/** 검색창에서 엔터 시 첫번째 검색 결과로 이동 */
const moveToFirstSearchResult = () => {
  const [first] = searchDYAMenu(
    adminMainStore.menu,
    adminMainStore.menuSearchKeyword,
    item => hasDYAMenuAuth(item, hasAuth)
  )
  if (!first) return

  adminMainStore.menuSearchKeyword = ''

  if (first.item.to) {
    router.push(first.item.to)
  } else if (first.item.href) {
    window.open(first.item.href, first.item.target ?? '_self')
  }
}
</script>

<style lang="scss">
.dya-menu-search {
  // 사이드바 색상(어두운색/흰색)에 관계없이 자연스럽게 보이도록 부모의 글자색을 그대로 사용한다
  .v-field {
    background-color: rgba(127, 127, 127, 0.18);
    color: inherit;
    font-size: 0.875rem;
  }

  .v-field__input,
  .v-field__prepend-inner .v-icon,
  .v-field__clearable .v-icon,
  input {
    color: inherit;
  }

  input::placeholder {
    color: inherit;
    opacity: 0.6;
  }
}

// 미니 사이드바(rail) 상태에서는 검색창을 숨김
.v-navigation-drawer--rail:not(.v-navigation-drawer--is-hovering) .dya-menu-search {
  display: none;
}
</style>